module.exports = __webpack_public_path__ + "static/media/btn-print.5272d28a.svg";